import { defaultHeightRange } from '../../../../../../cross-team-shared/state/layer-settings-state-3d';
import { Range } from '../../../../../../cross-team-shared/types/misc';
import { Point3D } from '../../../../../../team-apis/otterdam/answers/shape-typings';
import {
  cloudPalette,
  PointCloudPalette,
} from '../../../../../render/mesh/cloud/point-cloud-palette';
import { PointCloudContentState } from '../../../../../state/point-cloud-content-state';
import { getSensorLocation } from '../../../../../utils/location-utils';
import { CloudShaderMaterial } from '../../../cloud-shader-material';

export interface HeightModeUniforms {
  range: Range;
  palette: PointCloudPalette;
  sensorLocation: Point3D;
}

export const heightModeUniforms = `
  struct HeightModeUniforms {
    Range range;
    HSVPalette palette;
    vec3 sensorLocation;
  };
`;

export const getColorForHeightMode = `
  vec4 getColorForHeightMode() {
    HSVPalette palette = color.height.palette;
    Range range = color.height.range;
    vec3 sensorLocation = color.height.sensorLocation;

    float distance = abs(position.z - sensorLocation.z);
    float factor = distance / range.max;
    if (distance < range.min || factor > 1.0) {
      return vec4(0.478, 0.478, 0.478, 1.0);
    } else {
      return hsvToRgba(palette.min + (palette.max - palette.min) * factor);
    }
  }
`;

export function setHeightModeUniforms(
  material: CloudShaderMaterial,
  state?: PointCloudContentState,
) {
  const uniforms: HeightModeUniforms = {
    range: state ? state.render.layerSettings.heightRange : defaultHeightRange,
    palette: cloudPalette,
    sensorLocation: state ? getSensorLocation(state) : [0, 0, 0],
  };
  material.setColorUniform('height', uniforms);
}
